import {Injectable} from '@angular/core';
import {AuthStateService} from '@auth/states';
import {AppStateService, CompanyStateService} from '@core/states';
import {log} from '@core/utils';

@Injectable({
  providedIn: 'root'
})
export class AppInitialization {

  isInitalized = false;
  authInitialized = false;

  constructor(protected authState: AuthStateService, private appState: AppStateService, private companyState: CompanyStateService) {
  }

  async checkInitialization() {
    await this.initialize();
  }

  async initialize() {

    if (this.isInitalized && this.authInitialized) return;

    // States initialization
    if (!this.isInitalized) {
      await this.initializeBasicStore();
      this.isInitalized = true;
    }

    if (!this.authInitialized) {
      await this.initializeAuthBasicStore();
    }

  }

  async initializeBasicStore() {
    await this.authState.initialize();
    await this.appState.initialize();
  }

  async initializeAuthBasicStore() {
    if (!this.authState.isAuthenticated()){
      log.debug('User not authenticated: Authentication stores not initialized. Skipping...');
      return;
    }
    log.debug('User authenticated: Initializing Authentication stores.');
    await this.companyState.initialize();
    this.authInitialized = true;
  }

}
